import React, { useState } from 'react';
import { useEffect } from 'react';

const Footer = () => {
  const [scrollBtn, setScrollBtn] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function handleScroll() {
    if (window.scrollY > 70) {
      setScrollBtn(true);
    } else if (window.scrollY < 70) {
      setScrollBtn(false);
    }
  }

  const scrollTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <footer className='site-footer'>
        {/* <div className='site-footer__upper'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-3'>
                <div className='footer-widget footer-widget__about'>
                  <img
                    src={logo}
                    width='150'
                    alt=''
                    className='footer-widget__logo'
                  />
                  {footer_first_column.map((item) => {
                    return (
                      <p className='footer-widget__contact' key={item.id}>
                        {item.info}
                      </p>
                    );
                  })}
                </div>
              </div>
              <div className='col-lg-6 d-flex justify-content-between footer-widget__links-wrap'>
                <div className='footer-widget'>
                  <h3 className='footer-widget__title'>
                    {footer_second_col_title}
                  </h3>
                  <ul className='footer-widget__links list-unstyled'>
                    {footer_second_col.map((item) => {
                      return (
                        <li key={item.id}>
                          <a href={item.link}>{item.title}</a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className='footer-widget'>
                  <h3 className='footer-widget__title'>
                    {footer_third_col_title}
                  </h3>
                  <ul className='footer-widget__links list-unstyled'>
                    {footer_third_col.map((item) => {
                      return (
                        <li key={item.id}>
                          <a href={item.link}>{item.title}</a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className='footer-widget'>
                  <h3 className='footer-widget__title'>
                    {footer_fourth_col_title}
                  </h3>
                  <ul className='footer-widget__links list-unstyled'>
                    {footer_fourth_col.map((item) => {
                      return (
                        <li key={item.id}>
                          <a href={item.link}>{item.title}</a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className='col-lg-3'>
                <div className='footer-widget'>
                  <div className='site-footer__social'>
                    <a
                      href='#s-link'
                      aria-label='social icon'
                      aria-hidden='true'
                    >
                      <i className='fa fa-facebook-square'></i>
                    </a>
                    <a href='#none' aria-label='social icon' aria-hidden='true'>
                      <i className='fa fa-twitter'></i>
                    </a>
                    <a href='#none' aria-label='social icon' aria-hidden='true'>
                      <i className='fa fa-instagram'></i>
                    </a>
                    <a href='#none' aria-label='social icon' aria-hidden='true'>
                      <i className='fa fa-pinterest-p'></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className='site-footer__bottom'>
          <div className='container'>
            <div className='inner-container text-center'>
              <p className='site-footer__copy'>
                copyright &copy; {new Date().getFullYear()} cloudlaunch
              </p>
            </div>
          </div>
        </div>
      </footer>

      <div
        onClick={scrollTop}
        onKeyDown={scrollTop}
        role='button'
        tabIndex='0'
        className='scroll-to-target scroll-to-top'
        style={{ display: scrollBtn ? 'block' : 'none' }}
      >
        <i className='fa fa-angle-up'></i>
      </div>
    </div>
  );
};

export default Footer;
